

















































































































import VueOptions from '@utils/VueOptions'
import UiList from './List'

settings =
  name: 'ResourceList'

  vue:
    props: [
      'items'
      'bulkActionResultItems'
      'actions'
      'listItemComponent'
      'listItemActions'
      'selectedFilters'
      'selectedItems'
      'components'
      'options'
    ]
    components: {
      UiList,
    }

    data: ->
      rowSize: 3
      searchValue: ''
      previousSearch: ''

      activeFilter: false

    computed:
      itemActions: -> 
        actions = { hiToggleSelection: @hiToggleSelection }
        actions[k] = v for k,v of (@listItemActions || {})
        actions
      filterExists: -> @$slots['filters']?
      hasTitle: -> @$slots['title']?

      hasEmptySlot: -> @$slots['empty']?
      hasItems: -> !!(@items || []).length
      showEmptyMessage: -> @items isnt null and !@hasItems and !@requestIsPending

      hideSelectedItems: -> !@options?.hideSelectedItems

    methods:
      hiToggleFilterDisplay: ->
        @activeFilter = !@activeFilter

      hiToggleSelection: (item, index) ->
        if @selectedItems.includes(item)
          index ||= @selectedItems.indexOf(item)
          @$emit('update:selectedItems', @selectedItems.splice(index, 1))
        else
          @selectedItems.push(item)

      hiSearchChange: ->
        if @searchValue != @previousSearch
          @previousSearch = @searchValue
          @actions.hiSearchChange(@searchValue)
      itemIsSelected: (id) -> @selectedItems.find (i) -> i.id is id

      showIfSelectedItemsOnList: (item) ->
        @options?.showSelectedItemsOnList || !@itemIsSelected(item.id)

      selectIfSelectedItemsOnList: (item) ->
        x = @options?.showSelectedItemsOnList && @itemIsSelected(item.id)
        !!x

export default VueOptions.vue settings
